import React from "react"
import { graphql } from "gatsby"

import Layout from "§/src/components/layout"
import "./_style.scss"

import Error from "§/src/components/error"
import { isEmpty } from "lodash"
import SEO from "§/src/components/seo"
import { useTranslation } from "react-i18next"
import { GatsbyImage } from "gatsby-plugin-image"

// Components
import VideoFull from "§/src/components/sections/video-full"
import ImageText from "§/src/components/sections/image-text"
import TileContentVideo from "§/src/components/atoms/content/tile-content-video"

// Assets
import Flag from "§/src/images/svg/flag.svg";
import Finish from "§/src/images/svg/finish.svg";
import LineDesktop1 from "§/src/images/svg/line-desktop-1.svg";
import LineDesktop2 from "§/src/images/svg/line-desktop-2.svg";
import LineMobile1 from "§/src/images/svg/line-mobile-1.svg";
import LineMobile2 from "§/src/images/svg/line-mobile-2.svg";
import Ticket from "§/src/images/svg/ticket.svg";
import TicketMobile from "§/src/images/svg/ticket-mobile.svg";
import Globe from "§/src/images/svg/globe.svg";
import GlobeMobile from "§/src/images/svg/globe-mobile.svg";
import Envelope from "§/src/images/svg/envelope.svg";
import EnvelopeMobile from "§/src/images/svg/envelope-mobile.svg";
import PlayIcon from "§/src/images/svg/play.svg";

export function Head(props) {
  const data = props.pageContext.data || {}
  const seo = data.seo || {}

  return (
    <React.Fragment>
      <html lang={process.env.GATSBY_SITE_LANG.replace(/_/g, "-")}></html>
      <body className="campagna-2024"></body>
      <SEO seo={seo} lang={props?.data?.lang}/>
    </React.Fragment>
  )
}

const Campagna2024 = props => {

    const { t } = useTranslation()

    const data = props?.pageContext || {}

    const language = props?.data?.lang?.locale?.locale

    const hero = {
      pretitle: data?.acfPages_campagna2024.pretitoloHero,
      title: data?.acfPages_campagna2024?.titoloHero,
      image: data?.acfPages_campagna2024?.thumbnailVideoHero?.gatsbyImage1920,
      imageMobile: data?.acfPages_campagna2024?.thumbnailVideoHeroMobile?.gatsbyImage992,
      videoYt: data?.acfPages_campagna2024?.videoHero,
      videoVimeo: "https://vimeo.com/929853113",
      videoVimeoMobile: "https://vimeo.com/929856243",
      enableContent: true,
      type: 'bg-loop',
      titleTag: 'h1',
      pausable: true
    };

    const aboutUs = {
      titolo: data?.acfPages_campagna2024?.titoloScopri,
      testo: data?.acfPages_campagna2024?.pretitoloScopri,
      cta: data?.acfPages_campagna2024?.urlCtaScopri,
      ctaSelf: true,
      image: data?.acfPages_campagna2024?.immagineScopri?.gatsbyImage992,
      classeTitolo: "scopri-title mb-0",
      classeTesto: "scopri-content xevero h5 fw-700 text-base d-inline-block mb-2",
      reverse: true,
      ctaTesto: data?.acfPages_campagna2024?.testoCtaScopri
    };

    return (
        <Layout lang={["venezia-con-rivo"]} container="full" className="nobg-header" lang={props?.data?.lang}>
            {!isEmpty(data) ? (
                <React.Fragment>

                  <VideoFull data={hero} className="noheader bg-primary"/>

                  <section className={`schema bg-primary text-light ${language === 'it_IT' ? 'lang-it' : 'lang-en'}`}>
                    <div className="container">
                      <div className="schema-text" dangerouslySetInnerHTML={{ __html: data?.acfPages_campagna2024?.testoSchema }}/>

                      <h3 className="schema-title text-center">
                        {language === 'it_IT'
                          ? 'Dal 25 aprile al 14 luglio 2024'
                          : 'From April 25 to july 14, 2024'}
                      </h3>

                      <div className="schema-top d-flex justify-content-between align-items-center">
                        <i><Flag/></i>
                        <p className="text-center">
                          <span>
                            {language === 'it_IT' ? '29 giornate' : '29 days'}
                          </span> <br/>
                          {language === 'it_IT' ? 'di Contributo di Accesso' : 'of Access Fee'}
                        </p>
                        <i><Finish/></i>
                      </div>

                      <div className="schema-bottom">
                        <i className="line-desktop-1"><LineDesktop1/></i>
                        <i className="line-desktop-2"><LineDesktop2/></i>
                        <i className="line-mobile-1"><LineMobile1/></i>
                        <i className="line-mobile-2"><LineMobile2/></i>
                        <i className="ticket-1"><Ticket/></i>
                        <i className="ticket-2"><Ticket/></i>
                        <i className="ticket-mobile"><TicketMobile/></i>
                        <i className="globe"><Globe/></i>
                        <i className="globe-mobile"><GlobeMobile/></i>
                        <i className="envelope"><Envelope/></i>
                        <i className="envelope-mobile"><EnvelopeMobile/></i>

                        <div className="schema-text schema-text-1">
                          <h2>3,618,114</h2>
                          <p>{language === 'it_IT' ? 'prenotazioni giornaliere' : 'daily reservations'}</p>
                        </div>

                        <div className={`schema-text schema-text-2 ${language === 'it_IT' ? 'lang-it' : 'lang-en'}`}>
                          <h2>194 {language === 'it_IT' ? 'paesi' : 'countries'}</h2>
                          <p>
                            {language === 'it_IT'
                              ? 'di provenienza diversi hanno visitato cda.ve.it'
                              : 'of different origins have visited cda.ve.it'}
                          </p>
                        </div>

                        <div className="schema-text schema-text-3">
                          <h2>+ 15,000</h2>
                          <p>
                            {language === 'it_IT'
                              ? 'richieste di informazione gestite dal servizio Di.Me'
                              : 'information requests handled by the Di.Me service'}
                          </p>
                        </div>
                      </div>
                    </div>
                  </section>

                  {/* <VideoFull data={video} className="noheader video-campagna" /> */}

                  <TileContentVideo
                    playText={language === 'it_IT' ? 'Guarda la campagna pubblicitaria' : 'Check out the ad campaign'}
                    image={data?.acfPages_campagna2024?.thumbnailVideo?.gatsbyImage992}
                    video={data?.acfPages_campagna2024?.video}
                    hasIcon={true}
                    className="video-campagna"
                  />

                  <section className="gallery bg-success">
                    <div className="container">
                      <div className="d-grid grid-gallery">
                        {data?.acfPages_campagna2024?.griglia2x2Repeater?.map((item, index) => (
                          <GatsbyImage
                            key={`grid-${index}`}
                            image={item.imgGallery?.gatsbyImage}
                            objectFit="cover"
                            objectPosition="center"
                            alt={`Immagine galleria ${index + 1}`}
                          />
                        ))}
                      </div>

                      <div className="gallery-text text-light" dangerouslySetInnerHTML={{ __html: data?.acfPages_campagna2024?.testoGallerie }}/>
                    </div>

                    <div className="gallery-horizontal gallery-row-top">
                      {data?.acfPages_campagna2024?.galleriaOrizzontaleRepeater?.slice(0, 3).map((item, index) => (
                        <GatsbyImage
                          key={`horiz-top-${index}`}
                          image={item.imgGallery?.gatsbyImage}
                          objectFit="cover"
                          objectPosition="center"
                          alt={`Immagine galleria orizzontale ${index + 1}`}
                        />
                      ))}
                    </div>

                    <div className="gallery-horizontal gallery-row-bottom">
                      {data?.acfPages_campagna2024?.galleriaOrizzontaleRepeater?.slice(3, 6).map((item, index) => (
                        <GatsbyImage
                          key={`horiz-bottom-${index}`}
                          image={item.imgGallery?.gatsbyImage}
                          objectFit="cover"
                          objectPosition="center"
                          alt={`Immagine galleria orizzontale ${index + 4}`}
                        />
                      ))}
                    </div>
                  </section>

                  <section className="scopri position-relative text-light">
                    <ImageText data={aboutUs}/>
                  </section>

                </React.Fragment>
            ) : (
                <Error message="Something Went Wrong" />
            )}
        </Layout>
    )
}

export default Campagna2024

export const pageQuery = graphql`
  query GET_TRANSLATIONS($databaseId: Int!) {
    lang: wpPage(databaseId: { eq: $databaseId }) {
      locale {
        locale
      }
      translations {
        href
        locale
      }
      title
      uri
    }
  }
`
